$(document).ready(function() {
  var parentMemorialElement = $('.memorial-files');
  var validateMemorialFilesRules = {
    acceptFileTypes: /(\.|\/)(pdf)$/i,
    acceptFileTypesString: 'PDF',
    maxFileSize: 2000000,
    maxFilesQuantity: 1,
    removeAlert: null
  };

  var parentImagesElement = $('.images-files');
  var validateImagesFilesRules = {
    acceptFileTypes: /^image\/(gif|jpe?g|png)$/i,
    acceptFileTypesString: 'GIF, JPEG ou PNG',
    maxFileSize: 2000000,
    maxFilesQuantity: 5,
    removeAlert: null
  };

  $('.memorial-upload').fileupload({
    add: function (e, data) {
      if (!validateFiles(data, validateMemorialFilesRules, parentMemorialElement)) {
        return false;
      }

      parentMemorialElement.find('.fileinput-button').addClass('disabled');

      $('.memorial-files .progress').show();
      var jqXHR = data.submit();
    },
    progressall: function (e, data) {
      var progress = parseInt(data.loaded / data.total * 100, 10);
      $('.memorial-files .progress .progress-bar').css('width', progress + '%');
    },
    always: function(e, data) {
      console.log(e, 'event');
      console.log(data, 'data');

      $('.memorial-files .progress').hide();

      //This area will contain file list and progress information.
      var tpl = $(
        '<tr>' +
          '<td>' +
            '<a href="#" class="file-link">' +
              '<span class="icon icon-pdf"></span>' +
              '<span class="name"></span>' +
            '</a>' +
          '</td>' +
          '<td class="text-center">' +
            '<a href="#" class="file-link">' +
              '<span class="icon icon-preview"></span>' +
            '</a>' +
          '</td>' +
          '<td class="text-center">' +
            '<a href="#" class="file-link">' +
              '<span class="icon icon-download"></span>' +
            '</a>' +
          '</td>' +
          '<td class="text-center">' +
            '<a href="#" class="file-link">' +
              '<span class="icon icon-trash"></span>' +
            '</a>' +
          '</td>' +
        '</tr>'
      );

      if (data.files.length > 0) {
        // Append the file name and file size
        tpl.find('.file-link .name').text(data.files[0].name);

        // Add the HTML to the UL element
        data.context = tpl.appendTo($('.memorial-files tbody'));
        $('.memorial-files table').addClass('visible');
        parentMemorialElement.find('.fileinput-button').removeClass('disabled');
        $('.memorial-button').hide();
      }
    }
  });

  $('.images-upload').fileupload({
    acceptFileTypes: /(\.|\/)(gif|jpe?g|png)$/i,
    sequentialUploads: true,
    add: function (e, data) {
      if (!validateFiles(data, validateImagesFilesRules, parentImagesElement)) {
        return false;
      }

      parentImagesElement.find('.fileinput-button').addClass('disabled');

      $('.images-files .progress').show();
      var jqXHR = data.submit();
    },
    progressall: function (e, data) {
      var progress = parseInt(data.loaded / data.total * 100, 10);
      $('.images-files .progress .progress-bar').css('width', progress + '%');

      if (progress >= 100) {
        $('.images-files .progress .progress-bar').css('width', 0 + '%');
        $('.images-files .progress').hide();
      }
    },
    always: function(e, data) {
      var tpl = $(
        '<tr>' +
          '<td>' +
            '<a href="#" class="file-link">' +
              '<span class="icon icon-picture"></span>' +
              '<span class="name"></span>' +
            '</a>' +
          '</td>' +
          '<td class="text-center">' +
            '<a href="#" class="file-link">' +
              '<span class="icon icon-preview"></span>' +
            '</a>' +
          '</td>' +
          '<td class="text-center">' +
            '<a href="#" class="file-link">' +
              '<span class="icon icon-download"></span>' +
            '</a>' +
          '</td>' +
          '<td class="text-center">' +
            '<a href="#" class="file-link">' +
              '<span class="icon icon-trash"></span>' +
            '</a>' +
          '</td>' +
        '</tr>'
      );

      if (data.files.length > 0) {
        tpl.find('.file-link .name').text(data.files[0].name);

        data.context = tpl.appendTo($('.images-files tbody'));

        $('.images-files table').addClass('visible');
      }

      if (
          (parentImagesElement.find('tbody tr').length >=
          validateImagesFilesRules.maxFilesQuantity) ||
          (data.originalFiles.length >=
          validateImagesFilesRules.maxFilesQuantity)
      ) {
        parentImagesElement.find('.fileinput-button').hide();
        return false;
      } else {
        parentImagesElement.find('.fileinput-button').removeClass('disabled');
      }
    }
  });

  function formatFileSize(bytes) {
    if (typeof bytes !== 'number') {
      return '';
    }

    if (bytes >= 1000000000) {
      return (bytes / 1000000000).toFixed(2) + ' GB';
    }

    if (bytes >= 1000000) {
      return (bytes / 1000000).toFixed(2) + ' MB';
    }
    return (bytes / 1000).toFixed(2) + ' KB';
  }

  function validateFiles(data, validateFilesRules, parent) {
    var currentFile = data.files[0];
    var tpl = null;
    var uploadErrors = {
      acceptFileTypes: null,
      maxFileSize: null,
      maxFilesQuantity: null
    };

    if (!validateFilesRules.acceptFileTypes.test(currentFile.type)) {
      uploadErrors.acceptFileTypes = 'Tipo de arquivo não aceitado (deve ser '+validateFilesRules.acceptFileTypesString+'). ';
      tpl = $(
        '<div class="alert alert-danger" role="alert">' +
          uploadErrors.acceptFileTypes +
        '</div>'
      );
      tpl.insertAfter(parent.find('.progress'));
    }
    if (currentFile.size > validateFilesRules.maxFileSize) {
      uploadErrors.maxFileSize = 'Tamanho máximo por arquivo atingido ('+formatFileSize(validateFilesRules.maxFileSize)+').';
      tpl = $(
        '<div class="alert alert-danger" role="alert">' +
          uploadErrors.maxFileSize +
        '</div>'
      );
      tpl.insertAfter(parent.find('.progress'));
    }

    if ((data.originalFiles.length + parent.find('tbody tr').length) >
      validateFilesRules.maxFilesQuantity) {
      uploadErrors.maxFilesQuantity = 'Limite de quantidade atingido (insira no máximo 5 arquivos).';
      tpl = $(
        '<div class="alert alert-danger" role="alert">' +
          uploadErrors.maxFilesQuantity +
        '</div>'
      );
      tpl.insertAfter(parent.find('.progress'));
    }

    if (
      uploadErrors.acceptFileTypes ||
      uploadErrors.maxFileSize ||
      uploadErrors.maxFilesQuantity
    ) {
      if (validateFilesRules.removeAlert) {
        clearTimeout(validateFilesRules.removeAlert);
      }

      validateFilesRules.removeAlert = setTimeout(function() {
        parent.find('.alert').remove();
      }, 5000);

      uploadErrors = {
        acceptFileTypes: null,
        maxFileSize: null,
        maxFilesQuantity: null
      };

      return false;
    }

    return true;
  }

  $('.table-files tbody').bind("DOMSubtreeModified",function(){
    if ($('.table-files tbody tr').length >=
      validateMemorialFilesRules.maxFilesQuantity + validateImagesFilesRules.maxFilesQuantity) {
      $('.container-sendfiles').removeClass('hidden');

      $('body, html').animate({scrollTop: $('.container-sendfiles').offset().top - 200}, 650);
    }
  });
});
